import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 8 8",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M4.65949 4L7.97589 0.160736C8.03148 0.0969326 7.98474 0 7.89883 0H6.89064C6.83126 0 6.77441 0.0257668 6.73524 0.0699386L4 3.23681L1.26476 0.0699386C1.22686 0.0257668 1.17 0 1.10936 0H0.101173C0.015262 0 -0.0314836 0.0969326 0.0241056 0.160736L3.34051 4L0.0241056 7.83926C0.0116531 7.85348 0.00366439 7.87088 0.00108753 7.88938C-0.00148933 7.90788 0.00145395 7.92671 0.00956823 7.94363C0.0176825 7.96055 0.030627 7.97486 0.0468645 7.98485C0.063102 7.99484 0.0819506 8.0001 0.101173 8H1.10936C1.16874 8 1.22559 7.97423 1.26476 7.93006L4 4.76319L6.73524 7.93006C6.77315 7.97423 6.83 8 6.89064 8H7.89883C7.98474 8 8.03148 7.90307 7.97589 7.83926L4.65949 4Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
